<template>
  <v-container class="my-0">
    <c-card class="white">
      <div class="d-flex justify-end">
        <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div style="width: 200px">
              <v-text-field
                  v-model="startDate"
                  label="시작일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
              ></v-text-field>
            </div>
          </template>
          <c-date-picker v-model="startDate" @input="startMenu = false" firstDayOfWeek="1"
                         :selectedDate="startDate" locale="ko-kr"></c-date-picker>
        </v-menu>
        <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div class="ml-5" style="width: 200px">
              <v-text-field
                  v-model="endDate"
                  label="종료일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
              ></v-text-field>
            </div>
          </template>
          <c-date-picker v-model="endDate" @input="endMenu = false" firstDayOfWeek="1"
                         :selectedDate="endDate" locale="ko-kr"></c-date-picker>
        </v-menu>
      </div>

      <div class="black--text font-weight-bold subtitle-1">운행 누적 통계</div>
      <v-row class="mb-5">
        <v-col cols="12" sm="6" md="2" class="black--text font-weight-bold pl-7">총 운행 거리</v-col>
        <v-col cols="12" sm="2" md="1" class="black--text text-right font-weight-bold ">{{ $func.meterToKilometer(totalDistance) }} km</v-col>
        <v-col cols="12" sm="4" md="3"></v-col>

        <v-col cols="12" sm="6" md="2" class="black--text font-weight-bold">총 운행 시간</v-col>
        <v-col cols="12" sm="6" md="4" class="black--text font-weight-bold">{{ $func.secToTimeFormat2(totalOperatingTime) }}</v-col>

        <v-col cols="12" sm="6" md="2" class="pl-9">업무 운행 거리</v-col>
        <v-col cols="12" sm="2" md="1" class="black--text text-right">{{ $func.meterToKilometer(totalDistance - totalNonBusinessDistance) }} km</v-col>
        <v-col cols="12" sm="4" md="2"></v-col>

        <v-col cols="12" sm="12" md="6"></v-col>

        <v-col cols="12" sm="6" md="2" style="padding-left: 3.5%">탑승 거리</v-col>
        <v-col cols="12" sm="2" md="1" class="black--text text-right">{{ $func.meterToKilometer(totalBoardingDistance) }} km</v-col>
        <v-col cols="12" sm="4" md="3"></v-col>

        <v-col cols="12" sm="6" md="2">실차율</v-col>
        <v-col cols="12" sm="6" md="4" class="black--text">{{ totalBoardingDistance ? (totalBoardingDistance / (totalBoardingDistance +  totalEmptyDistance) * 100).toFixed(3) : '0.000' }} %</v-col>

        <v-col cols="12" sm="6" md="2" style="padding-left: 3.5%">빈차 거리</v-col>
        <v-col cols="12" sm="2" md="1" class="black--text text-right">{{ $func.meterToKilometer(totalEmptyDistance) }} km</v-col>
        <v-col cols="12" sm="4" md="3"></v-col>

        <v-col cols="12" sm="6" md="2" style="padding-top: 0 !important; margin-top: -12px;"><div class="caption">탑승 거리 / (탑승 거리 + 빈차 거리)</div></v-col>
        <v-col cols="12" sm="6" md="4"></v-col>

        <v-col cols="12" sm="6" md="2" class="pl-9">비업무 운행 거리</v-col>
        <v-col cols="12" sm="2" md="1" class="black--text text-right">{{ $func.meterToKilometer(totalNonBusinessDistance) }} km</v-col>
        <v-col cols="12" sm="4" md="3"></v-col>
      </v-row>

      <div class="black--text font-weight-bold subtitle-1 mb-3">운행 기록</div>
      <c-table :headers="tableHeaders" hide-default-footer :items="resultLog" :items-per-page="-1">
        <template #startTime="{ item }">
          {{ item.startTime ? $func.dateTimeToString(item.startTime) : '-'}}
        </template>
        <template #endTime="{ item }">
          {{ item.endTime ? $func.dateTimeToString(item.endTime) : '-'}}
        </template>
        <template #operatingTime="{ item }">
          {{ item.operatingTime && item.operatingTime !== 0 ? $func.formatSecToTime(item.operatingTime) : '-' }}
        </template>
        <template #startOdoDistance="{ item }">
          <span :class="setStartTextColor(item)">{{ item.startOdoDistance!=null ? $func.meterToKilometer(item.startOdoDistance) : '-' }}</span>
        </template>
        <template #endOdoDistance="{ item }">
          <span :class="setEndTextColor(item)">{{ item.endOdoDistance!=null ? $func.meterToKilometer(item.endOdoDistance) : '-' }}</span>
        </template>
        <template #operatingDistance="{ item }">
          {{ item.endOdoDistance!=null ? $func.meterToKilometer(item.operatingDistance) : '-' }}
        </template>
        <template #boardingDistance="{ item }">
          {{ item.endTime ? $func.meterToKilometer(item.boardingDistance) : '-' }}
        </template>
        <template #emptyDistance="{ item }">
          {{ item.endTime ? $func.meterToKilometer(item.emptyDistance) : '-' }}
        </template>
        <template #updated="{ item }">
          {{ item.updated ? $func.dateTimeToString(item.updated) : '-'}}
        </template>
        <template #update="{ item }">
          <v-icon v-if="item.endOdoDistance && item.startTime" @click="openUpdateDialog(item)">edit</v-icon>
        </template>
      </c-table>
    </c-card>

    <odo-distance-update-dialog
      :open.sync="updateFlag"
      :odo-distance-data="updateRowData"
      @reqOdoDistanceLog="reqOdoDistanceLog"
    />
  </v-container>
</template>

<script>
import OdoDistanceUpdateDialog from "@/views/Default/Vehicle/OdoDistnaceUpdateDialog";

export default {
  components: {OdoDistanceUpdateDialog},
  data() {
    return {
      updateFlag: false,

      startMenu: false,
      endMenu: false,
      startDate: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
      endDate: this.$func.curDateString(),
      tableHeaders: [
        {
          text: '번호',
          sortable: false,
          align: 'center',
          value: 'number'
        },
        {
          text: '기사 이름',
          sortable: false,
          align: 'center',
          value: 'driverName'
        },
        {
          text: '운행 시작 일시',
          sortable: false,
          align: 'center',
          value: 'startTime'
        },
        {
          text: '운행 종료 일시',
          sortable: false,
          align: 'center',
          value: 'endTime'
        },
        {
          text: '운행 시간',
          sortable: false,
          align: 'center',
          value: 'operatingTime'
        },
        {
          text: '시작 계기판 거리(km)',
          sortable: false,
          align: 'center',
          value: 'startOdoDistance'
        },
        {
          text: '종료 계기판 거리(km)',
          sortable: false,
          align: 'center',
          value: 'endOdoDistance'
        },
        {
          text: '운행 거리(km)',
          sortable: false,
          align: 'center',
          value: 'operatingDistance'
        },
        {
          text: '탑승 거리(km)',
          sortable: false,
          align: 'center',
          value: 'boardingDistance'
        },
        {
          text: '빈차 거리(km)',
          sortable: false,
          align: 'center',
          value: 'emptyDistance'
        },
        {
          text: '업데이트 일시',
          sortable: false,
          align: 'center',
          value: 'updated'
        },
        {
          text: '수정',
          sortable: false,
          align: 'center',
          value: 'update'
        },
      ],
      odoDistanceLog: [],
      resultLog: [],

      totalDistance: 0,
      totalOperatingTime: 0,
      totalBoardingDistance: 0,

      totalEmptyDistance: 0,

      updateRowData: null,
    }
  },
  watch: {
    startDate() {
      this.reqOdoDistanceLog();
    },
    endDate() {
      this.reqOdoDistanceLog();
    }
  },
  computed: {
    totalNonBusinessDistance() {
      return this.resultLog.filter(item => item.nonBusinessFlag).reduce(function add(sum, currValue) {
        return sum + currValue.operatingDistance;
      }, 0);
    },
  },
  mounted() {
    this.reqOdoDistanceLog();
  },
  methods: {
    async reqOdoDistanceLog() {
      try {
        this.initData();

        const res = await this.$api.getOdoDistanceInfo(this.$route.params.vehicleId, this.startDate, this.endDate);
        let length = res.data.length;
        this.odoDistanceLog = await res.data.map((item, idx) => {
          this.totalBoardingDistance += item.boardingDistance;
          this.totalOperatingTime += item.operatingTime;
          const newItem = {...item};

          newItem.number = length - idx;
          newItem.operatingDistance = item.endOdoDistance ? item.endOdoDistance - item.startOdoDistance : null;
          newItem.emptyDistance = item.emptyDistance ? (item.boardingDistance > newItem.operatingDistance ? 0 : item.emptyDistance)  : null;

          this.totalEmptyDistance += newItem.emptyDistance;
          return newItem;
        });

        if (length > 0) {
          const startDistance = this.odoDistanceLog[length - 1].startOdoDistance;

          if(!this.odoDistanceLog.find(item => item.endOdoDistance)){
            this.endDistance = null;
            this.totalDistance = null;
          } else {
            this.endDistance = this.odoDistanceLog.find(item => item.endOdoDistance).endOdoDistance;
            this.totalDistance = this.endDistance - startDistance;
          }
          await this.processOdoDistanceLog();
        }

      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqOdoDistanceLog'});
      }
      
    },
    openUpdateDialog(rowData) {
      this.updateFlag = true;
      this.updateRowData = rowData;
    },
    async processOdoDistanceLog() {
      const odoDistanceLog = this.odoDistanceLog;
      const result = [];

      // 이전 index의 종료값과 현재의 시작값을 비교하기 위해 계속 update됨
      let endDistance = odoDistanceLog[odoDistanceLog.length -1].startOdoDistance;

      for (let i = odoDistanceLog.length - 1; i >= 0; i--) {
        const data = odoDistanceLog[i];
        if (!endDistance || data.startOdoDistance === endDistance) result.push(data);
        else {
          if (endDistance < data.startOdoDistance) {
            result.push({
              nonBusinessFlag: true,
              startOdoDistance: endDistance,
              endOdoDistance: data.startOdoDistance,
              operatingDistance: endDistance && data.startOdoDistance ? data.startOdoDistance - endDistance : null
            });
            result.push(data);
          } else {
            const newData = {...data};
            newData.startFlag = true;
            result.push(newData);
          }
        }
        endDistance = odoDistanceLog[i].endOdoDistance;
      }

      // startFlag 찾아 이전 인덱스에 endFlag 설정
      for (let i = 0; i < result.length; i++) {
       if (i !== 0 && result[i].endOdoDistance && result[i].startFlag) {
         const newItem = result[i -1];
         newItem.endFlag = true;
         result[i - 1] = newItem;
       }
      }

      this.resultLog = result.reverse();
    },
    setStartTextColor(item) {
      return (item.startFlag && item.endOdoDistance) ? 'red--text' : null;
    },
    setEndTextColor(item) {
      return (item.endFlag && item.endOdoDistance) ? 'red--text' : null;
    },
    initData() {
      this.totalDistance = 0;
      this.totalOperatingTime = 0;
      this.totalBusinessDistance = 0;
      this.totalNonBusinessDistance = 0;
      this.totalBoardingDistance = 0;
      this.totalEmptyDistance = 0;
    }
  },
}
</script>

<style scoped>

</style>